import { NavigationItem, AIStudioCategory } from '../types/header'

// AI 스튜디오 카테고리 정의
export const AI_STUDIO_CATEGORIES: AIStudioCategory[] = [
  {
    title: '영상',
    icon: '/assets/img/icons/video-icon.svg',
    items: [
      {
        name: 'AI 영상',
        path: '/ai-studio/video/ai-video',
        description: '이미지를 움직이는 영상으로 만들기',
        icon: '/assets/img/ai-studio/ai-video.jpg',
      },
      {
        name: '립씽크 영상',
        path: '/ai-studio/video/lip-sync',
        description: '캐릭터가 주어진 대사를 립싱크로 말하기',
        icon: '/assets/img/ai-studio/lip-sync.jpg',
      },
      {
        name: 'UGC 영상',
        path: '/ai-studio/video/ugc',
        description: '직접 만든 리뷰, 체험담 스타일 립싱크 영상',
        icon: '/assets/img/ai-studio/ugc.jpg',
        isPreparing: true,
      },
    ],
  },
  {
    title: '이미지',
    icon: '/assets/img/icons/image-icon.svg',
    items: [
      {
        name: '상품 + 캐릭터 이미지',
        path: '/ai-studio/image/product-character',
        description: '상품과 캐릭터가 합성된 이미지 생성',
        icon: '/assets/img/ai-studio/product-character.jpg',
      },
      {
        name: '배경 만들기',
        path: '/ai-studio/image/background',
        description: '아이템을 돋보이게 하는 배경 생성',
        icon: '/assets/img/ai-studio/background.jpg',
      },
      {
        name: '스타일 이미지',
        path: '/ai-studio/image/style',
        description: '스타일을 선택하여 여러 이미지를 합성',
        icon: '/assets/img/ai-studio/style.jpg',
      },
    ],
  },
  {
    title: '컨텐츠',
    icon: '/assets/img/icons/content-icon.svg',
    items: [
      {
        name: '뉴스/블로그 링크로 만들기',
        path: '/short-video-editor?createType=link',
        description: '링크 내용을 기반으로 영상 생성',
        icon: '🔗',
      },
      {
        name: '텍스트로 만들기 - 다국어지원',
        path: '/short-video-editor?createType=text',
        description: '직접 입력한 내용으로 영상 생성',
        icon: '📝',
      },
    ],
  },
]

// 새로운 GNB 네비게이션 - 왼쪽 그룹 (로고와 함께)
export const LEFT_NAV: NavigationItem[] = [
  {
    name: '상품 영상',
    path: 'video-editor',
    textMain: true,
    event: false,
  },
  {
    name: '컨텐츠 영상',
    path: 'short-video-editor',
    textMain: true,
    event: false,
    children: [], // AI 스튜디오 서브메뉴는 별도 컴포넌트에서 처리
  },
  {
    name: '스타일룸',
    path: 'ai-studio',
    textMain: true,
    event: false,
    children: [], // AI 스튜디오 서브메뉴는 별도 컴포넌트에서 처리
  },
  {
    name: '생성 내역',
    path: 'my-videos',
    textMain: true,
    event: false,
    user: true, // 로그인 필요
  },
  {
    name: 'AI 이미지·영상',
    path: 'ai/create',
    textMain: true,
    event: true,
  },
]

// 새로운 GNB 네비게이션 - 오른쪽 그룹
export const RIGHT_NAV: NavigationItem[] = [
  {
    name: '가격 안내',
    path: 'price-guide',
    textMain: true,
    event: false,
  },
  {
    name: '챌린지',
    path: 'challenge',
    textMain: true,
    event: true,
  },
]

// 언어 및 사용자 메뉴
export const LANGUAGE_MENU = {
  name: '한국어',
  path: 'language',
}

// 기존 NEW_GNB는 호환성을 위해 유지하되 새로운 구조로 변경
export const NEW_GNB: NavigationItem[] = [...LEFT_NAV, ...RIGHT_NAV]

// 기존 컨텐츠 영상 서브메뉴 (참고용)
export const CONTENT_VIDEO_SUBMENU = [
  {
    name: '링크로 만들기',
    path: '/short-video-editor?createType=link',
    description: '링크 내용을 기반으로 영상 생성',
  },
  {
    name: '텍스트로 만들기 - 다국어 지원 🌏',
    path: '/short-video-editor?createType=text',
    description: '직접 입력한 내용으로 영상 생성',
  },
]

// PC 사용자 메뉴 (Figma 디자인 기반)
export const PC_USER_MENU = [
  {
    name: '내 플랜',
    path: 'my-payments',
    icon: 'Smile',
  },
  {
    name: '캐시 관리',
    path: 'my-cash-dashboard',
    icon: 'PieChart',
  },
  { name: 'line', path: '' },
  {
    name: '초대코드',
    path: 'my-page',
    icon: 'Users',
  },
  {
    name: '자동 업로드 설정',
    path: 'youtube-auth',
    icon: 'Youtube',
  },
  { name: 'line', path: '' },
  {
    name: '패스트컷 블로그',
    path: 'blog',
    icon: 'BookOpen',
  },
  {
    name: '많이 묻는 질문+빠른 해결법',
    path: 'faq',
    icon: 'HelpCircle',
  },
  {
    name: '로그아웃',
    path: 'logout',
    icon: 'LogOut',
  },
]

// 모바일 로그인 사용자 메뉴 (Figma 디자인 기반)
export const MOBILE_USER_MENU = [
  {
    name: '🎁 상품 영상 만들기',
    path: 'video-editor',
    user: false,
    highlighted: false, // 프레임으로 강조
  },
  {
    name: '🎬 컨텐츠 영상 만들기',
    path: 'short-video-editor?createType=link',
    user: false,
  },

  {
    name: '👗 스타일룸',
    path: 'ai-studio',
    user: false,
  },
  {
    icon: 'ShoppingBag',
    name: '상품 영상 생성 내역',
    path: 'my-videos?type=plv',
    user: true,
  },
  {
    icon: 'StyleShot',
    name: '스타일룸 생성 내역',
    path: 'gallery',
    user: true,
  },
  {
    icon: 'Film',
    name: '컨텐츠 영상 생성내역',
    path: 'my-videos?type=lcv',
    user: true,
  },

  { name: 'line', path: '' },
  {
    name: '상품 영상 플랜 가격',
    path: 'price-guide',
    icon: 'ShoppingBag',
  },

  {
    name: '스타일룸 가격',
    path: 'styleRoom-price-guide',
    icon: 'StyleShot',
  },
  {
    name: '컨텐츠 영상 가격',
    path: 'shortform-price-guide',
    icon: 'Film',
  },

  {
    name: '챌린지',
    path: 'challenge',
    icon: 'Award',
    event: true,
    badge: '페이백',
  },
  { name: 'line', path: '' },
  {
    name: '내 플랜',
    path: 'my-payments',
    icon: 'Smile',
  },
  {
    name: '캐시 관리',
    path: 'my-cash-dashboard',
    icon: 'PieChart',
  },
  {
    name: '초대코드',
    path: 'my-page',
    icon: 'Users',
  },
  {
    name: '자동 업로드 설정',
    path: 'youtube-auth',
    icon: 'Youtube',
  },
  {
    name: '패스트컷 블로그',
    path: 'blog',
    icon: 'BookOpen',
  },
  {
    name: '많이 묻는 질문+빠른 해결법',
    path: 'faq',
    icon: 'HelpCircle',
  },
  {
    name: '로그아웃',
    path: 'logout',
    icon: 'LogOut',
  },
]

// 모바일 비로그인 사용자 메뉴
export const MOBILE_GUEST_MENU = [
  {
    name: '🎁 상품 영상 만들기',
    path: 'video-editor',
    user: false,
    highlighted: false, // 프레임으로 강조
  },
  {
    name: '🎬 컨텐츠 영상 만들기',
    path: 'short-video-editor?createType=link',
    user: false,
  },
  {
    name: '👗 스타일룸',
    path: 'ai-studio',
    user: false,
  },
  { name: 'line', path: '' },
  {
    name: '상품 영상 플랜 가격',
    path: 'price-guide',
    icon: 'ShoppingBag',
  },
  {
    name: '스타일룸 가격',
    path: 'styleRoom-price-guide',
    icon: 'StyleShot',
  },
  {
    name: '컨텐츠 영상 가격',
    path: 'shortform-price-guide',
    icon: 'Film',
  },
  {
    name: '챌린지',
    path: 'challenge',
    icon: 'Award',
    event: true,
    badge: '페이백',
  },
  { name: 'line', path: '' },
  {
    name: '패스트컷 블로그',
    path: 'blog',
    icon: 'BookOpen',
  },
  {
    name: '많이 묻는 질문+빠른 해결법',
    path: 'faq',
    icon: 'HelpCircle',
  },
  {
    name: '로그인',
    path: 'sign-in',
    icon: 'LogIn',
  },
  { name: '회원 가입', path: 'sign-up' },
]
